/* eslint-disable jsx-a11y/alt-text */
import "../styles/desktop.scss";
export function DesktopComponent() {
  return (
    <div id="landingPageWrapper">
      <div id="desktopContentContainer">
        <div id="arTextWrapper">
          <img id="arTextDesktop" />
        </div>
        <div id="logoDesktopWrapper">
          <img id="logoDesktop" />
        </div>
        <div id="leftColumnDesktop">
          <img id="qrCodeDesktop" />
          <div id="scanTextDesktop">
            scan qr code or visit
            <br />
            {window.location.href}
          </div>
        </div>
      </div>
    </div>
  );
}
